<template>
    <div class="body">
      <div class="header">
        <el-form :model="UserFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="姓名">
              <el-input
                size="small"
                v-model="UserFindDTO.contacts"
                placeholder="姓名"
              ></el-input>
            </el-form-item>
          <el-form-item label="登录手机">
              <el-input
                size="small"
                v-model="UserFindDTO.access"
                placeholder="登录手机"
              ></el-input>
            </el-form-item>
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <br>
          <el-form-item>
            <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增员工"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >

          <el-form-item label="*登入手机" prop="access">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.access"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
 
    <el-form-item  label="密码" prop="password">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="姓名" prop="contacts">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.contacts"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        
        <el-form-item  label="地址" prop="address">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.address"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item  label="qq" prop="qq">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.qq"
            placeholder="请输入qq"
          ></el-input>
        </el-form-item>
        <el-form-item  label="权限级别" prop="levelCode">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.levelCode"
            placeholder="请输入权限级别"
          ></el-input>
        </el-form-item>
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑员工" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="登入手机" prop="access">
            <el-input v-model="accountForm.access" ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="accountForm.password" ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="contacts">
            <el-input v-model="accountForm.contacts" ></el-input>
          </el-form-item>
          
          <el-form-item label="地址" prop="address">
            <el-input v-model="accountForm.address" ></el-input>
          </el-form-item>
          <el-form-item label="qq" prop="qq">
            <el-input v-model="accountForm.qq" ></el-input>
          </el-form-item>
          <el-form-item label="权限级别" prop="levelCode">
            <el-input v-model="accountForm.levelCode" ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
          <el-table-column
            prop="access"
            align="center"
            label="登录手机"
          ></el-table-column>
          <el-table-column
            prop="password"
            align="center"
            label="密码"
  
          ></el-table-column>
          <el-table-column
            prop="contacts"
            align="center"
            label="姓名"
    
          ></el-table-column>
   
          <el-table-column
            prop="address"
            align="center"
            label="地址"
          ></el-table-column>
          <el-table-column
              prop="qq"
              align="center"
              label="qq"
            ></el-table-column>
            <el-table-column
              prop="levelCode"
              align="center"
              label="权限级别"
            ></el-table-column>
         
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
  
 
    </div>
  </template>
  
  <script>
  import { userSelectInfo,bathDeleteUser,addUser,upDateUser } from '@/api/order/staff.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        UserFindDTO:{
            pid:'',
            startTime: '',
            endTime: '',
            access: '',
            contacts:''
        },
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          pid:'',
          access:'',
          phone:'',
          password:'',
          userName:'',
          address:'',
          levelCode:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
                  access:[
                    { required: true, message: '请输入手机号', trigger: 'blur' }],
                    password:[
                    { required: true, message: '请输密码', trigger: 'blur' }]
            }

      }
    },
    
  
    mounted() {
      this.UserFindDTO.pid=localStorage.getItem("access")
      this.accountForm.pid=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.pid=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        userSelectInfo(this.currentPage, this.pageSize, this.UserFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addUser(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.da
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
   //修改
   editAccount() {
    upDateUser(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteUser(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.UserFindDTO.startTime = e[0]
          this.UserFindDTO.endTime = e[1]
        } else if (!e) {
          this.UserFindDTO.startTime = ''
          this.UserFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .btn-style{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  </style>
  